var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "language-list-card",
      on: {
        click: function ($event) {
          return _vm.destinationSelected(_vm.item)
        },
      },
    },
    [
      _c("span", {
        staticClass: "language-list-card-label",
        domProps: {
          innerHTML: _vm._s(
            _vm.parsedHotelLabel ? _vm.parsedHotelLabel : _vm.item.label
          ),
        },
      }),
      _vm._v(" "),
      _vm.isSelecting
        ? _c("span", { staticClass: "icon-loading-black" })
        : _vm.localValue
        ? _c("span", {
            staticClass: "language-list-card-icon icon-checkmark-circle",
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }